var _defs, _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _polygon2, _polygon3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _path27, _polygon4, _polygon5, _polygon6, _path28, _polygon7, _polygon8, _polygon9, _rect2, _polygon10, _polygon11, _polygon12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoworkingMonochromatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 519.25,
    height: 482.26,
    viewBox: "0 0 519.25 482.26",
    "data-imageid": "coworking-monochromatic",
    imageName: "Coworking",
    className: "illustrations_image",
    style: {
      width: 237
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 293.86,
    y1: 452.52,
    x2: 144.98,
    y2: 349.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 456.28,
    y1: 175.34,
    x2: 465.37,
    y2: 492.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 83.16,
    y1: 395.13,
    x2: 238.32,
    y2: 395.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 235.79,
    y1: 358.5,
    x2: 192.01,
    y2: 572.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 279.23,
    y1: 106.22,
    x2: 274.13,
    y2: 116.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 273.73,
    y1: 100.95,
    x2: 277.45,
    y2: 94.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 382.27,
    y1: 278.15,
    x2: 136.34,
    y2: 329.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 226.2,
    y1: 238.13,
    x2: 385.84,
    y2: 238.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f0dcce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 290.49,
    y1: 271.09,
    x2: 260.71,
    y2: 370.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 189.31,
    y1: 254.86,
    x2: 13.41,
    y2: 176.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 210.92,
    y1: 155.92,
    x2: 224.98,
    y2: 168.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 216.8,
    y1: 183.71,
    x2: 227.27,
    y2: 32.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 234.38,
    y1: 123.6,
    x2: 275.92,
    y2: 133.16,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 216.09,
    y1: 155.84,
    x2: 176.38,
    y2: 148.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 374.65,
    y1: 206.68,
    x2: 433.84,
    y2: 253.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 380.51,
    y1: 209.14,
    x2: 431.23,
    y2: 249.46,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 424.46,
    y1: 250.03,
    x2: 412.42,
    y2: 251.98,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 412.63,
    y1: 225.76,
    x2: 423.52,
    y2: 257.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 248.03,
    y1: 323.45,
    x2: 388.64,
    y2: 323.45,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 265.85,
    y1: 227.72,
    x2: 315.21,
    y2: 232.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 158.31,
    y1: 253.94,
    x2: 321.44,
    y2: 253.94,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 252.1,
    y1: 194.27,
    x2: 288.49,
    y2: 194.27,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 262.06,
    y1: 186.7,
    x2: 262.65,
    y2: 200.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 338.24,
    y1: 290.96,
    x2: 340.26,
    y2: 318.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 265.83,
    y1: 277.45,
    x2: 250.67,
    y2: 546.81,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drink Coffee with Laptop in Cafe") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M522.84,318.93c-10.48,12.44-23.21,23-32.14,36.62-10.48,15.95-15.1,35-22.24,52.75a109.37,109.37,0,0,1-11.73,22.37,78.93,78.93,0,0,1-8.07,9.67c-24.31,24.94-63,32.93-98.51,36.8a917.38,917.38,0,0,1-143.43,4.33c-21-1-40.15-4.42-60,.89-19.37,5.17-40.13-4.14-55.76-15.07-20.83-14.56-38.58-34.18-48.36-57.64s-11.08-50.9-.92-74.21c13.94-32,46.79-52.52,61.46-84.19,7.34-15.86,9.64-33.54,11.46-50.94Q119,158,120.46,115.4c.64-18.93.94-38.39,8.28-55.84,12-28.66,41.46-47,71.8-53.69s61.88-3.44,92.75.1C346.06,12,399.43,19.05,448.66,39l1.15.46c3.91,1.6,7.9,3.35,10.77,6.44,4.89,5.23,5.52,13,7.05,20,.25,1.13.52,2.24.83,3.35,8.83,32.3,39.82,53.65,59.89,80.91C564.38,199,562,272.5,522.84,318.93Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.05,32.73a3.86,3.86,0,0,1,1.49-2,5.36,5.36,0,0,1,2.77-.59,3.41,3.41,0,0,1,2.76,1c.53.64.8,2,.8,3.93,0,3.48,0,6.71.11,9.71s.1,4.29.1,3.9c0,1.67-.28,2.8-.85,3.38a4.18,4.18,0,0,1-3,.88q-3.51,0-4.57-5c-.25-1-.44-1.75-.59-2.29a10.87,10.87,0,0,0-4.83-6.51,16,16,0,0,0-9-2.52,18.63,18.63,0,0,0-15.1,6.87q-5.69,6.89-5.69,18.46t5.77,18.46a18.91,18.91,0,0,0,15.23,6.87,23.82,23.82,0,0,0,6.28-.87A27.56,27.56,0,0,0,193,83.71a34.38,34.38,0,0,0,3.94-2.52c1.66-1.19,2.85-1.78,3.56-1.78a3.87,3.87,0,0,1,2.79,1.09,3.55,3.55,0,0,1,1.14,2.68,4.61,4.61,0,0,1-1.25,3.06,21,21,0,0,1-4.65,3.6,35.07,35.07,0,0,1-9,4.34A32.15,32.15,0,0,1,180,95.57q-13.14,0-21.69-9.28t-8.56-23.74q0-14.29,8.66-23.76a28.32,28.32,0,0,1,21.8-9.47,31.78,31.78,0,0,1,7.15.85A47.65,47.65,0,0,1,195.05,32.73Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,38.63h-7.77a8.51,8.51,0,0,1-4.54-.88,3.29,3.29,0,0,1-1.31-3,3.48,3.48,0,0,1,1.15-3Q224,31,229.13,31h15.16c2,0,3.27.26,4,.77a6.75,6.75,0,0,1,1.89,2.85l20.78,51.94h.91a6.94,6.94,0,0,1,3.93.8,3.38,3.38,0,0,1,1.07,2.87,3.72,3.72,0,0,1-1,3A6.26,6.26,0,0,1,272,94H257.58c-2.7,0-4.42-.28-5.18-.83a3.45,3.45,0,0,1-1.15-3,3.15,3.15,0,0,1,1.25-2.84c.83-.55,2.4-.83,4.71-.83h4.94L257,73.88H230l-4.58,12.65h5.16c2.34,0,3.93.28,4.79.83a3.11,3.11,0,0,1,1.27,2.84,3.47,3.47,0,0,1-1.14,3c-.76.55-2.44.83-5,.83h-14c-2.27,0-3.77-.28-4.52-.83a3.52,3.52,0,0,1-1.11-3A3.31,3.31,0,0,1,212,87.33c.75-.53,2.18-.8,4.31-.8h1Zm-2.72,28.18h21.75L243,38.63Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51,86.53h2.08a4.86,4.86,0,0,1,3.24.88,3.51,3.51,0,0,1,1,2.79,3.89,3.89,0,0,1-1,2.84,3.67,3.67,0,0,1-2.76,1H284.91a3.68,3.68,0,0,1-2.77-1,3.89,3.89,0,0,1-1-2.84,3.46,3.46,0,0,1,1-2.82,5.7,5.7,0,0,1,3.54-.85h5.1V38.63h-3.35c-2.69,0-4.42-.28-5.18-.83a3.46,3.46,0,0,1-1.15-3,3.89,3.89,0,0,1,1-2.84,3.68,3.68,0,0,1,2.77-1h47a3.43,3.43,0,0,1,2.74,1.09,4.76,4.76,0,0,1,.93,3.17V48.94a3.79,3.79,0,0,1-.93,2.79,3.68,3.68,0,0,1-2.74.93,3.42,3.42,0,0,1-3-1.17c-.53-.77-.8-2.53-.8-5.26v-7.6H299.26V56.55h14V55.16c0-2.58.24-4.32.74-5.21a2.8,2.8,0,0,1,2.66-1.33,2.92,2.92,0,0,1,2.47,1,5.38,5.38,0,0,1,.77,3.25v13.5a6.81,6.81,0,0,1-.71,3.67,2.92,2.92,0,0,1-2.53,1A2.78,2.78,0,0,1,314,69.73c-.5-.88-.74-2.62-.74-5.21V63h-14V86.53Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,94H349a4,4,0,0,1-2.9-1,3.81,3.81,0,0,1-1-2.87,3.25,3.25,0,0,1,1.15-2.9c.76-.51,2.5-.77,5.23-.77h3.41V38.63h-3.41c-2.65,0-4.38-.28-5.18-.83a3.38,3.38,0,0,1-1.2-3,3.81,3.81,0,0,1,1-2.9,4.21,4.21,0,0,1,3-.93h46.31a3.43,3.43,0,0,1,2.74,1.09,4.76,4.76,0,0,1,.93,3.17V47.77a6.69,6.69,0,0,1-.8,3.83,3.38,3.38,0,0,1-2.87,1.06,3.42,3.42,0,0,1-3-1.17c-.55-.77-.83-2.53-.83-5.26v-7.6H363.33V56.55h13.93V53.73a7.36,7.36,0,0,1,.77-4,3,3,0,0,1,2.68-1.12,2.76,2.76,0,0,1,2.58,1.2Q384,51,384,55v9.89q0,4-.75,5.1a2.93,2.93,0,0,1-2.65,1.12A2.77,2.77,0,0,1,378,69.78c-.47-.85-.71-2.5-.71-4.94V63H363.33V86.53h28.28V77.92q0-4.1.83-5.26a3.42,3.42,0,0,1,3-1.17,3.33,3.33,0,0,1,2.84,1.09c.55.72.83,2.1.83,4.12V90.09a4.09,4.09,0,0,1-1,2.93,3.57,3.57,0,0,1-2.71,1Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 117.35,
    y: 424.09,
    width: 14.34,
    height: 54.04,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.51,365.15s29.77,7.44,36.39,17.37-25.64,100.9-25.64,100.9l-45.49-1.65L241,404Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.51,365.15s29.77,7.44,36.39,17.37-25.64,100.9-25.64,100.9l-45.49-1.65L241,404Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M468.46,69.17V408.3a109.37,109.37,0,0,1-11.73,22.37,78.93,78.93,0,0,1-8.07,9.67V39l1.15.46c3.91,1.6,7.9,3.35,10.77,6.44,4.89,5.23,5.52,13,7.05,20C467.88,67,468.15,68.06,468.46,69.17Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468.46,69.17V408.3a109.37,109.37,0,0,1-11.73,22.37,78.93,78.93,0,0,1-8.07,9.67V39l1.15.46c3.91,1.6,7.9,3.35,10.77,6.44,4.89,5.23,5.52,13,7.05,20C467.88,67,468.15,68.06,468.46,69.17Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8,349c-4.59,5.67-6.47,13.16-6.63,20.46-.48,22.84,15,43.68,34.48,55.67s42.43,16.64,65,20.46c14.76,2.5,30.74,4.56,44-2.33,5-2.58,9.51-6.64,11.07-12,2.81-9.68-4.65-19.11-12-26A244.89,244.89,0,0,0,158,360C141.76,352.74,103.92,331.57,89.8,349Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8,349c-4.59,5.67-6.47,13.16-6.63,20.46-.48,22.84,15,43.68,34.48,55.67s42.43,16.64,65,20.46c14.76,2.5,30.74,4.56,44-2.33,5-2.58,9.51-6.64,11.07-12,2.81-9.68-4.65-19.11-12-26A244.89,244.89,0,0,0,158,360C141.76,352.74,103.92,331.57,89.8,349Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.15,477.14l-15.95,2.74-25.37,4.37-65.34-73.61s-104.78,8.82-120.21-22.06c-8.16-16.31-7.39-40-4.86-58.72a230.93,230.93,0,0,1,6-29.5s37.5,20.95,83.82,28.67S350.15,477.14,350.15,477.14Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.2,479.88l-25.37,4.37-65.34-73.61s-104.78,8.82-120.21-22.06c-8.16-16.31-7.39-40-4.86-58.72,7.2,8,45.41,48,87.57,44.94C258.33,371,308.18,437.81,334.2,479.88Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M287.37,108.1a14.52,14.52,0,0,1-3.86,8.73,47.21,47.21,0,0,1-5.85,5.06,78.41,78.41,0,0,0-10.72,10.37c0-3.91,0-7.88,1.08-11.64a48.47,48.47,0,0,0,1.57-5.24c.56-3.24-.34-6.61.28-9.84a18.84,18.84,0,0,1,2.18-5.37c.86-1.57,1.88-3.21,3.52-3.92a5.58,5.58,0,0,1,4.49.22C284.4,98.47,287.65,103.31,287.37,108.1Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M287.37,108.1a14.52,14.52,0,0,1-3.86,8.73,47.21,47.21,0,0,1-5.85,5.06,78.41,78.41,0,0,0-10.72,10.37c0-3.91,0-7.88,1.08-11.64a48.47,48.47,0,0,0,1.57-5.24c.56-3.24-.34-6.61.28-9.84a18.84,18.84,0,0,1,2.18-5.37c.86-1.57,1.88-3.21,3.52-3.92a5.58,5.58,0,0,1,4.49.22C284.4,98.47,287.65,103.31,287.37,108.1Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-5)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M281,98.36",
    transform: "translate(-34.6 -1.99)",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M283.9,98.41c1.27-2.61,2-5.67,1-8.4a1.06,1.06,0,0,0-1.29-.85A25.52,25.52,0,0,0,269.17,94a18.51,18.51,0,0,1,5.55,7,12.87,12.87,0,0,1,1,5.41c0,.39-.39,1.88-.06,2.06s1.47-1.11,1.71-1.36A34.9,34.9,0,0,0,283.9,98.41Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#2b2a44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.9,98.41c1.27-2.61,2-5.67,1-8.4a1.06,1.06,0,0,0-1.29-.85A25.52,25.52,0,0,0,269.17,94a18.51,18.51,0,0,1,5.55,7,12.87,12.87,0,0,1,1,5.41c0,.39-.39,1.88-.06,2.06s1.47-1.11,1.71-1.36A34.9,34.9,0,0,0,283.9,98.41Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-6)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "296.55 247.64 166.97 351.85 482.93 352.4 421.17 245.43 296.55 247.64",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "319.16 254.99 361.44 254.62 359.23 269.32 314.01 267.49 319.16 254.99",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.21 186.98 402.98 300.94 275.05 303.14 286.94 284.86 290.12 279.99 325.7 279.37 396.36 278.15 429.07 184.04 441.21 186.98",
    fill: "#68e1fd",
    className: "target-color"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382.36,286l-12.65-.71a5.16,5.16,0,0,0-2.54.29,7.06,7.06,0,0,0-2,1.94,13,13,0,0,1-7.61,4,37.09,37.09,0,0,1-8.75.26,41,41,0,0,1-9.38-1.23c-2.08-.6-4.05-1.51-6.09-2.22a29.84,29.84,0,0,0-11.8-1.54l3.17-4.88,35.59-.62c1.08.22,2.18.41,3.29.57,4.42.61,8.93.47,13.35,1.08C379.1,283.3,381.54,284,382.36,286Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-7)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M385.84,280.24s-1.93,4.31-3.77,3.58-13.24-5.51-13.24-5.51a11.73,11.73,0,0,1-4.36,3.47,16.73,16.73,0,0,1-5.93,1.67c-7.35.73-27.93-2.94-27.93-2.94l-85.29,6.25L226.2,269.49l1.59-46.91,1.12-33.08,30.75,68.59s90.16,4.13,104.22,10.75S385.84,280.24,385.84,280.24Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-8)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M364.47,281.78a16.73,16.73,0,0,1-5.93,1.67c-7.35.73-27.93-2.94-27.93-2.94l-85.29,6.25L226.2,269.49l1.59-46.91,18.63,41.57s90.16,4.14,104.22,10.75C356.28,277.55,360.92,279.91,364.47,281.78Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-9)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M230,190.61c.1.86.21,1.72.36,2.57,1.33,7.73,8.28,48.22,9.78,57.5,1.38,8.47-7.19,24.16-10.24,29.39-.74,1.27-1.42,2.58-2,3.91l-16,34.92a45.06,45.06,0,0,1-57.34,23.17h0a45.07,45.07,0,0,1-26.05-57.2c15.59-43.52,39.3-106.8,48.06-114.75C189.89,158,225.25,150.69,230,190.61Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.1,178.28c-11.58-2.53-24.78,2.53-31.84,8.93-8.77,7.95-32.48,71.24-48.06,114.75a45,45,0,0,0,3.92,38.63,45,45,0,0,1-22.67-55.72c15.59-43.52,39.3-106.79,48.06-114.74C188.3,159.43,217.14,152.49,227.1,178.28Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-10)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.28,164.16s-12,6.07-8.54,18.61-22.06-16-22.06-16-3.31-19.3,16.54-17.64S233.28,164.16,233.28,164.16Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-11)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M204.2,168.57s3.86-7.58,7-9.23,9.51-1.93,9.92,3.72a45.24,45.24,0,0,0,2.9,11.72s5.51-8.69,9.23-10.62c0,0-10.47-7.17-13.37-11.71s-14.2,3.86-14.2,3.86S200.75,165,204.2,168.57Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-12)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273.92,116.1c-1.84,6.53-5.49,13.08-3.94,19.68a24.66,24.66,0,0,1,.94,4,3.75,3.75,0,0,1-1.61,3.57,7.46,7.46,0,0,1-2.1.54c-5,1-8,6.12-10,10.83s-4.23,10-8.92,12c-3.94,1.75-8.58.67-12.48-1.16a40.83,40.83,0,0,1-16.22-14.18A27.92,27.92,0,0,1,215,141.1a31.44,31.44,0,0,1-.09-9.19,62.64,62.64,0,0,1,8.41-26,44.78,44.78,0,0,1,20.25-18,23.29,23.29,0,0,1,7.34-2c5.06-.38,10.07,1.6,14.22,4.53,3.21,2.26,8.9,6.34,10,10.31C276.38,105.3,275.17,111.7,273.92,116.1Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-13)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M261.06,101a138.79,138.79,0,0,0-22.83,30.17c-2.66,4.75-5.07,9.71-8.57,13.87a33.17,33.17,0,0,1-16.93,10.67,13.43,13.43,0,0,0-4,1.42c-2.85,1.83-3.43,5.67-5.16,8.57-2.26,3.8-6.56,6-10.87,6.94s-8.77,1-13.16,1.52c-16.16,2-27.22,53.8-34.91,68.16.92-7.23-23.16-26.84-1.09-63.2,2-3.31,1-7.84-.3-11.5-1.52-4.36-5.47-8.46-4.09-12.87a9.7,9.7,0,0,1,4-4.74c7-4.91,16.25-6.45,22.41-12.42-.37,1.13-2.2,1-2.88.07a4.27,4.27,0,0,1-.25-3.44c1.55-6.43,6-11.8,10.87-16.22s10.43-8.16,15.16-12.78c-3.3-1.28-4.43-5.72-3.11-9s4.36-5.53,7.46-7.22,6.45-3,9.16-5.27c3-2.52,5-6,7.74-8.87,4.28-4.5,10.1-7.16,15.8-9.63a45.91,45.91,0,0,1,10.87-3.59,29.75,29.75,0,0,1,12.71,1c11,3.17,20,10.89,28.37,18.6,1.94,1.77,3.86,3.55,5.78,5.35,1,1,2.13,2.16,1.91,3.55s-9.22.82-11.1,1.52C269,93.53,264.78,97.22,261.06,101Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M261.06,101a138.79,138.79,0,0,0-22.83,30.17c-2.66,4.75-5.07,9.71-8.57,13.87a33.17,33.17,0,0,1-16.93,10.67,13.43,13.43,0,0,0-4,1.42c-2.85,1.83-3.43,5.67-5.16,8.57-2.26,3.8-6.56,6-10.87,6.94s-8.77,1-13.16,1.52c-16.16,2-27.22,53.8-34.91,68.16.92-7.23-23.16-26.84-1.09-63.2,2-3.31,1-7.84-.3-11.5-1.52-4.36-5.47-8.46-4.09-12.87a9.7,9.7,0,0,1,4-4.74c7-4.91,16.25-6.45,22.41-12.42-.37,1.13-2.2,1-2.88.07a4.27,4.27,0,0,1-.25-3.44c1.55-6.43,6-11.8,10.87-16.22s10.43-8.16,15.16-12.78c-3.3-1.28-4.43-5.72-3.11-9s4.36-5.53,7.46-7.22,6.45-3,9.16-5.27c3-2.52,5-6,7.74-8.87,4.28-4.5,10.1-7.16,15.8-9.63a45.91,45.91,0,0,1,10.87-3.59,29.75,29.75,0,0,1,12.71,1c11,3.17,20,10.89,28.37,18.6,1.94,1.77,3.86,3.55,5.78,5.35,1,1,2.13,2.16,1.91,3.55s-9.22.82-11.1,1.52C269,93.53,264.78,97.22,261.06,101Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "396.36 278.15 401.69 299.1 438.63 186.62 429.07 184.04 396.36 278.15",
    opacity: 0.69,
    fill: "url(#linear-gradient-15)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.12 270.39 403.68 288.35 435.35 191.94 427.15 189.74 399.12 270.39",
    opacity: 0.69,
    fill: "url(#linear-gradient-16)",
    style: {
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "338.83 281.46 334.97 297.63 343.79 297.26 345.08 281.82 338.83 281.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.54 281.27 383.26 281.41 385.61 295.75 381.19 295.75 379.54 281.27",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.27 281.2 376.99 281.2 379.26 295.7 372.46 295.61 371.27 281.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.37 281.46 369.25 281.46 369.98 295.79 363 295.79 363.37 281.46",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.19 281.64 361.16 281.55 361.62 296.44 354.54 296.44 355.19 281.64",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.47 281.82 352.7 281.92 352.52 296.8 346.09 296.8 347.47 281.82",
    fill: "#fff"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M401.5,238.33s3.86,23.34,5.15,24.63l20.4-.37s4-20.58,3.49-23.34l-6.06-2.2Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.18,240.39s3.13,20.77,4.42,22.06l17.45.14s4-20.58,3.49-23.34l-6.06-2.2Z",
    transform: "translate(-34.6 -1.99)",
    opacity: 0.69,
    fill: "url(#linear-gradient-17)",
    style: {
      isolation: "isolate"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M427.05,262.59s4-20.58,3.49-23.34",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M399.26,230.91a1.58,1.58,0,0,1-.81-.78c-.25-.77.73-1.36,1.52-1.5a8.57,8.57,0,0,1,5.36.84A40,40,0,0,1,397.7,222a18.87,18.87,0,0,1,6.89,3,10.16,10.16,0,0,1,6-5.06,19.9,19.9,0,0,1,8-.76,2.84,2.84,0,0,1,2.35,1c.52.87,0,2-.48,2.85a4.39,4.39,0,0,1,4.17-2.72q-1.53,2.84-3.33,5.5c1.58-1.15,3.67-1.23,5.63-1.27a1.52,1.52,0,0,1,.87.17c.59.44.19,1.38-.29,1.94-2,2.35-4.82,4.18-5.9,7.08a38.5,38.5,0,0,0-1,4.66,2.29,2.29,0,0,1-.55,1.15,2.42,2.42,0,0,1-1.34.51c-3.21.52-7.44,1-9.93-1.5A43.73,43.73,0,0,0,399.26,230.91Z",
    transform: "translate(-34.6 -1.99)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M399.26,230.91a1.58,1.58,0,0,1-.81-.78c-.25-.77.73-1.36,1.52-1.5a8.57,8.57,0,0,1,5.36.84A40,40,0,0,1,397.7,222a18.87,18.87,0,0,1,6.89,3,10.16,10.16,0,0,1,6-5.06,19.9,19.9,0,0,1,8-.76,2.84,2.84,0,0,1,2.35,1c.52.87,0,2-.48,2.85a4.39,4.39,0,0,1,4.17-2.72q-1.53,2.84-3.33,5.5c1.58-1.15,3.67-1.23,5.63-1.27a1.52,1.52,0,0,1,.87.17c.59.44.19,1.38-.29,1.94-2,2.35-4.82,4.18-5.9,7.08a38.5,38.5,0,0,0-1,4.66,2.29,2.29,0,0,1-.55,1.15,2.42,2.42,0,0,1-1.34.51c-3.21.52-7.44,1-9.93-1.5A43.73,43.73,0,0,0,399.26,230.91Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-18)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.33 313.25 386.98 310.5 390.84 340.27 250.24 339.17 267.33 313.25",
    fill: "#dedee0"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.12 311.32 384.78 308.57 388.64 338.34 248.03 337.24 265.12 311.32",
    opacity: 0.69,
    fill: "url(#linear-gradient-19)",
    style: {
      isolation: "isolate"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.65 219.79 254.37 196.91 286.9 196.63 279.46 260.04 259.89 260.32 253.27 238.81 254.65 219.79",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.65 219.79 254.37 196.91 286.9 196.63 279.46 260.04 259.89 260.32 253.27 238.81 254.65 219.79",
    fill: "url(#linear-gradient-20)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M302.05,260.21q-38.24,30.48-78.55,58.2c-10.61,7.3-22.05,14.7-34.91,15.24-4,.17-8.14-.4-11.41-2.65-5.18-3.55-6.93-10.26-8.18-16.41-6.79-33.42-9.91-67.53-10.63-101.63-.16-7.69-.18-15.55,2.32-22.82s8-14,15.47-15.82c0,0,17.7-2.44,22.85,15.94s0,98.15,3.67,98.89S279.51,252,279.51,252c1.55,0,1.86-2.77,2.09-4.31a18.92,18.92,0,0,0-.15-4.63,41,41,0,0,1,6.47-26c1.54,2.25,1.47,5.2,1.34,7.92L289,231a3.08,3.08,0,0,0,.43,2.16,2.58,2.58,0,0,0,1.65.77c2.89.44,5.74-.81,8.45-1.93a120.18,120.18,0,0,1,17.56-5.76,3.43,3.43,0,0,1,2.83.15,2.68,2.68,0,0,1,.56,3.11c-.39,1.06-1.11,2-1.44,3.08a1.38,1.38,0,0,0,0,1c.26.52,1,.59,1.43.92a3,3,0,0,1,.85,2.42l.07,2.24c.15,4.72.21,9.79-2.4,13.74a15.49,15.49,0,0,1-8.06,5.75A37,37,0,0,1,302.05,260.21Z",
    transform: "translate(-34.6 -1.99)",
    fill: "url(#linear-gradient-21)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "252.63 198.38 288.83 198.38 288.83 194.34 286.08 193.78 285.53 189.74 255.01 190.11 253.91 194.15 252.44 194.89 252.63 198.38",
    fill: "#68e1fd",
    className: "target-color"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "252.28 198.59 288.49 198.59 288.49 194.54 285.73 193.99 285.18 189.95 254.67 190.31 253.57 194.36 252.1 195.09 252.28 198.59",
    opacity: 0.69,
    fill: "url(#linear-gradient-22)",
    style: {
      isolation: "isolate"
    }
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.01 190.11 256.44 184.78 269.4 189.88 255.01 190.11",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.01 190.11 256.44 184.78 269.4 189.88 255.01 190.11",
    fill: "url(#linear-gradient-23)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.97,
    y: 351.85,
    width: 314.85,
    height: 10.48,
    fill: "#dedee0"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.16 300.02 275.12 303.03 275.12 306.15 403.16 303.14 403.16 300.02",
    fill: "#68e1fd",
    className: "target-color"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.16 300.02 275.12 303.03 275.12 306.15 403.16 303.14 403.16 300.02",
    fill: "url(#linear-gradient-24)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "284.98 288.17 240.59 292.02 252.17 283.2 290.12 279.99 284.98 288.17",
    fill: "url(#linear-gradient-25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoworkingMonochromatic);
export default __webpack_public_path__ + "static/media/coworking-monochromatic.69be9501d71a53a261a6315264f6213a.svg";
export { ForwardRef as ReactComponent };